import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken, getUsername, clearSession, me } from "@/lib/apiClient";

/**
 * Wraps a protected route. Verifies the token with the backend once on mount.
 * On failure, clears session and redirects to /login.
 */
export default function RequireAuth({ children }) {
  const location = useLocation();
  const [state, setState] = useState(getToken() ? "checking" : "denied");

  useEffect(() => {
    const onExpire = () => setState("denied");
    window.addEventListener("vv:auth-expired", onExpire);
    return () => window.removeEventListener("vv:auth-expired", onExpire);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const token = getToken();
    if (!token) {
      setState("denied");
      return;
    }
    me()
      .then(() => { if (!cancelled) setState("allowed"); })
      .catch(() => {
        if (cancelled) return;
        clearSession();
        setState("denied");
      });
    return () => { cancelled = true; };
  }, []);

  if (state === "checking") {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <p className="text-[10px] uppercase tracking-[0.3em] font-bold text-white/40">
          Verifying session…
        </p>
      </div>
    );
  }

  if (state === "denied") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return typeof children === "function" ? children({ username: getUsername() }) : children;
}
